import type { TimeZoneChoices } from '@/types/serializers'
import { requestJson } from './http.ts'

const pending = new Map<string, Promise<TimeZoneChoices>>()
const loaded = new Map<string, TimeZoneChoices>()

export function loadedTimeZoneChoices(key: string): TimeZoneChoices | null {
  return loaded.get(key) ?? null
}

export function fetchTimeZoneChoices(url: string, key: string): Promise<TimeZoneChoices> {
  const inFlight = pending.get(key)
  if (inFlight) return inFlight

  const request = requestJson<TimeZoneChoices>(url).then((result) => {
    if (!result.ok) throw new Error(`time zone choices request failed: ${result.status}`)
    return result.data
  })

  request.then(
    (choices) => {
      loaded.set(key, choices)
      pending.delete(key)
    },
    () => pending.delete(key),
  )
  pending.set(key, request)
  return request
}
